import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import FooterMenu from "../components/footer-menu/footer-menu"
import Wrapper from "../components/wrapper/wrapper"
import Floorplan from "../components/floorplan/floorplan"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import { graphql } from "gatsby"
import { animated, useSpring } from "react-spring"

import "./floorplans.sass"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

//Majestic Villa
import s101 from "../images/floorplans/s101_large.jpg"
import s102 from "../images/floorplans/s102_large.jpg"
import s103 from "../images/floorplans/s103_large.jpg"
import s105 from "../images/floorplans/s105_large.jpg"
import s106 from "../images/floorplans/s106_large.jpg"
import s107 from "../images/floorplans/s107_large.jpg"
import s108 from "../images/floorplans/s108_large.jpg"
import s109 from "../images/floorplans/s109_large.jpg"
import majestic_villa from "../images/floorplans/majestic_villa.pdf"

//Premium Suite
import a from "../images/floorplans/a_large.jpg"
import b from "../images/floorplans/b_large.jpg"
import b1 from "../images/floorplans/b1_large.jpg"
import premium from "../images/floorplans/premium.pdf"

//Estate Penthouse
import f1 from "../images/floorplans/f1_large.jpg"
import f2 from "../images/floorplans/f2_large.jpg"
import l from "../images/floorplans/l_large.jpg"
import l1 from "../images/floorplans/l1_large.jpg"
import l2 from "../images/floorplans/l2_large.jpg"
import l3 from "../images/floorplans/l3_large.jpg"
import l1401 from "../images/floorplans/1401_large.jpg"
import l1402 from "../images/floorplans/1402_large.jpg"
import estate_penthouse from "../images/floorplans/estate_penthouse.pdf"

//Private Residence
import c from "../images/floorplans/c_large.jpg"
import c1 from "../images/floorplans/c1_large.jpg"
import d from "../images/floorplans/d_large.jpg"
import d1 from "../images/floorplans/d1_large.jpg"
import e from "../images/floorplans/e_large.jpg"
import e1 from "../images/floorplans/e1_large.jpg"
import n1 from "../images/floorplans/n1_large.jpg"
import private_residence from "../images/floorplans/private.pdf"

const Floorplans = props => {
  const fade = useSpring({
    from: {
      opacity: 0,
      transform: "translate3d(0, 30px, 0)",
    },
    to: {
      opacity: 1,
      transform: "translate3d(0, 0, 0)",
    },
  })
  return (
    <Layout>
      <SEO title="Floorplans" />
      <animated.div style={fade} id="floorplan">
        <h1 className="page-title">floorplans</h1>
        <Tabs>
          <TabList>
            <Tab>majestic villas</Tab>
            <Tab>premium suite</Tab>
            <Tab>estate penthouse</Tab>
            <Tab>private residence</Tab>
          </TabList>
          <Wrapper>
            <TabPanel>
              <div className="desc-container">
                <p className="desc">
                  Select from a range of 1, 2 and 3 bedroom floorplans below.
                  Plans may vary based on layout. Please contact your sales
                  representative for the most up-to-date information.
                </p>
                <a
                  href={majestic_villa}
                  className="download_pdf_inline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  download all floorplans pdf
                  <FontAwesomeIcon
                    icon={["fal", "arrow-to-bottom"]}
                    className="fa-icon"
                  />
                </a>
                <div className="floorplans">
                  <Floorplan
                    src={props.data.s101.childImageSharp.fluid}
                    href={s101}
                    planTitle="suite 101"
                    enclosed="2,345ft"
                    outdoor="635ft"
                    total="2,980ft"
                  />
                  <Floorplan
                    src={props.data.s102.childImageSharp.fluid}
                    href={s102}
                    planTitle="suite 102"
                    enclosed="2,293ft"
                    outdoor="656ft"
                    total="2,949ft"
                  />
                  <Floorplan
                    src={props.data.s103.childImageSharp.fluid}
                    href={s103}
                    planTitle="suite 103"
                    enclosed="2,573ft"
                    outdoor="672ft"
                    total="3,245ft"
                  />
                  <Floorplan
                    src={props.data.s105.childImageSharp.fluid}
                    href={s105}
                    planTitle="suite 105"
                    enclosed="2,328ft"
                    outdoor="703ft"
                    total="3,031ft"
                  />
                  <Floorplan
                    src={props.data.s106.childImageSharp.fluid}
                    href={s106}
                    planTitle="suite 106"
                    enclosed="3,419ft"
                    outdoor="970ft"
                    total="4,389ft"
                  />
                  <Floorplan
                    src={props.data.s107.childImageSharp.fluid}
                    href={s107}
                    planTitle="suite 107"
                    enclosed="2,106ft"
                    outdoor="632ft"
                    total="2,738ft"
                  />
                  <Floorplan
                    src={props.data.s108.childImageSharp.fluid}
                    href={s108}
                    planTitle="suite 108"
                    enclosed="2,223ft"
                    outdoor="806ft"
                    total="3,029ft"
                  />
                  <Floorplan
                    src={props.data.s109.childImageSharp.fluid}
                    href={s109}
                    planTitle="suite 109"
                    enclosed="2,250ft"
                    outdoor="601ft"
                    total="2,851ft"
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="desc-container">
                <p className="desc">
                  Select from a range of 1, 2 and 3 bedroom floorplans below.
                  Plans may vary based on layout. Please contact your sales
                  representative for the most up-to-date information.
                </p>
                <a
                  href={premium}
                  className="download_pdf_inline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  download all floorplans pdf
                  <FontAwesomeIcon
                    icon={["fal", "arrow-to-bottom"]}
                    className="fa-icon"
                  />
                </a>
                <div className="floorplans">
                  <Floorplan
                    src={props.data.a.childImageSharp.fluid}
                    href={a}
                    planTitle="plan A"
                    enclosed="1,060ft"
                    outdoor="122 - 147ft"
                    total="1,182 - 1,207ft"
                  />
                  <Floorplan
                    src={props.data.b.childImageSharp.fluid}
                    href={b}
                    planTitle="plan B"
                    enclosed="1,127 - 549ft"
                    outdoor="165 - 200ft"
                    total="1,292 - 1,327ft"
                  />
                  <Floorplan
                    src={props.data.b1.childImageSharp.fluid}
                    href={b1}
                    planTitle="plan B1"
                    enclosed="1,103ft"
                    outdoor="165ft"
                    total="1,268ft"
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="desc-container">
                <p className="desc">
                  Select from a range of 1, 2 and 3 bedroom floorplans below.
                  Plans may vary based on layout. Please contact your sales
                  representative for the most up-to-date information.
                </p>
                <a
                  href={estate_penthouse}
                  className="download_pdf_inline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  download all floorplans pdf
                  <FontAwesomeIcon
                    icon={["fal", "arrow-to-bottom"]}
                    className="fa-icon"
                  />
                </a>
                <div className="floorplans">
                  <Floorplan
                    src={props.data.f1.childImageSharp.fluid}
                    href={f1}
                    planTitle="plan F1"
                    enclosed="3,187ft"
                    outdoor="1,632ft"
                    total="4,819ft"
                  />
                  <Floorplan
                    src={props.data.f2.childImageSharp.fluid}
                    href={f2}
                    planTitle="plan F2"
                    enclosed="3,809ft"
                    outdoor="1,789ft"
                    total="5,598ft"
                  />
                  <Floorplan
                    src={props.data.l.childImageSharp.fluid}
                    href={l}
                    planTitle="plan L"
                    enclosed="2,705ft"
                    outdoor="1,041ft"
                    total="3,746ft"
                  />
                  <Floorplan
                    src={props.data.l1.childImageSharp.fluid}
                    href={l1}
                    planTitle="plan L1"
                    enclosed="2,575ft"
                    outdoor="945ft"
                    total="3,520ft"
                  />
                  <Floorplan
                    src={props.data.l2.childImageSharp.fluid}
                    href={l2}
                    planTitle="plan L2"
                    enclosed="2,810ft"
                    outdoor="1,047ft"
                    total="3,857ft"
                  />
                  <Floorplan
                    src={props.data.l3.childImageSharp.fluid}
                    href={l3}
                    planTitle="plan L3"
                    enclosed="2,697ft"
                    outdoor="959ft"
                    total="3,656ft"
                  />
                  <Floorplan
                    src={props.data.l1401.childImageSharp.fluid}
                    href={l1401}
                    planTitle="Suite 1401"
                    enclosed="2,940ft"
                    outdoor="1,269ft"
                    rooftop="1,579ft"
                    total="5,788ft"
                  />
                  <Floorplan
                    src={props.data.l1402.childImageSharp.fluid}
                    href={l1402}
                    planTitle="suite 1402"
                    enclosed="3,131ft"
                    outdoor="1,116ft"
                    rooftop="1,793ft"
                    total="6,040ft"
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="desc-container">
                <p className="desc">
                  Select from a range of 1, 2 and 3 bedroom floorplans below.
                  Plans may vary based on layout. Please contact your sales
                  representative for the most up-to-date information.
                </p>
                <a
                  href={private_residence}
                  className="download_pdf_inline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  download all floorplans pdf
                  <FontAwesomeIcon
                    icon={["fal", "arrow-to-bottom"]}
                    className="fa-icon"
                  />
                </a>
                <div className="floorplans">
                  <Floorplan
                    src={props.data.c.childImageSharp.fluid}
                    href={c}
                    planTitle="plan C"
                    enclosed="1,496ft"
                    outdoor="177 - 227ft"
                    total="1,673 - 1,723ft"
                  />
                  <Floorplan
                    src={props.data.c1.childImageSharp.fluid}
                    href={c1}
                    planTitle="plan C1"
                    enclosed="1,486ft"
                    outdoor="177ft"
                    total="1,663ft"
                  />
                  <Floorplan
                    src={props.data.d.childImageSharp.fluid}
                    href={d}
                    planTitle="plan D"
                    enclosed="1,582ft"
                    outdoor="173 - 215ft"
                    total="1,755 - 1,797ft"
                  />
                  <Floorplan
                    src={props.data.d1.childImageSharp.fluid}
                    href={d1}
                    planTitle="plan D1"
                    enclosed="1,568ft"
                    outdoor="171 - 249ft"
                    total="1,739 - 1,817ft"
                  />
                  <Floorplan
                    src={props.data.e.childImageSharp.fluid}
                    href={e}
                    planTitle="plan E"
                    enclosed="1,977ft"
                    outdoor="300 - 369ft"
                    total="2,277 - 2,346ft"
                  />
                  <Floorplan
                    src={props.data.e1.childImageSharp.fluid}
                    href={e1}
                    planTitle="plan E1"
                    enclosed="1,769ft"
                    outdoor="282 - 332ft"
                    total="2,051 - 2,101ft"
                  />
                  <Floorplan
                    src={props.data.n1.childImageSharp.fluid}
                    href={n1}
                    planTitle="plan N1"
                    enclosed="1,825 - 1,833ft"
                    outdoor="177ft"
                    total="2,002 - 2,010ft"
                  />
                </div>
              </div>
            </TabPanel>
          </Wrapper>
        </Tabs>
      </animated.div>
      <FooterMenu />
    </Layout>
  )
}

export default Floorplans

export const floorplanQuery = graphql`
  query {
    f1: file(relativePath: { eq: "floorplans/f1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    f2: file(relativePath: { eq: "floorplans/f2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    l: file(relativePath: { eq: "floorplans/l.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    l1: file(relativePath: { eq: "floorplans/l1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    l2: file(relativePath: { eq: "floorplans/l2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    l3: file(relativePath: { eq: "floorplans/l3.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    l1401: file(relativePath: { eq: "floorplans/1401.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    l1402: file(relativePath: { eq: "floorplans/1402.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    s101: file(relativePath: { eq: "floorplans/s101.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    s102: file(relativePath: { eq: "floorplans/s102.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    s103: file(relativePath: { eq: "floorplans/s103.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    s105: file(relativePath: { eq: "floorplans/s105.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    s106: file(relativePath: { eq: "floorplans/s106.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    s107: file(relativePath: { eq: "floorplans/s107.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    s108: file(relativePath: { eq: "floorplans/s108.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    s109: file(relativePath: { eq: "floorplans/s109.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    a: file(relativePath: { eq: "floorplans/a.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    b: file(relativePath: { eq: "floorplans/b.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    b1: file(relativePath: { eq: "floorplans/b1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    c: file(relativePath: { eq: "floorplans/c.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    c1: file(relativePath: { eq: "floorplans/c1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    d: file(relativePath: { eq: "floorplans/d.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    d1: file(relativePath: { eq: "floorplans/d1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    e: file(relativePath: { eq: "floorplans/e.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    e1: file(relativePath: { eq: "floorplans/e1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    n1: file(relativePath: { eq: "floorplans/n1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
